import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { INTAKE_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IMedication } from '../../../../../pages/common';
import type {
  CreateIntakeMedicationPayload,
  DeleteAllIntakeMedicationsPayload,
  DeleteIntakeMedicationPayload,
  SetIntakeHasNoMedicationsPayload,
  UpdateIntakeMedicationPayload,
} from './types';

export function createIntakeMedicationThunks() {
  return {
    createIntakeMedication: createIntakeMedication(),
    updateIntakeMedication: updateIntakeMedication(),
    deleteIntakeMedication: deleteIntakeMedication(),
    deleteAllIntakeMedications: deleteAllIntakeMedications(),
    setIntakeHasNoMedications: setIntakeHasNoMedications(),
  };
}

function createIntakeMedication() {
  return createAsyncThunk<IMedication, CreateIntakeMedicationPayload>(
    'intakeQuestionnaire/createIntakeMedication',
    async ({ intakeQuestionnaireId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/medication`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function updateIntakeMedication() {
  return createAsyncThunk<IMedication, UpdateIntakeMedicationPayload>(
    'intakeQuestionnaire/updateIntakeMedication',
    async ({ intakeQuestionnaireId, medicationId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/medication/${medicationId}`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteIntakeMedication() {
  return createAsyncThunk<void, DeleteIntakeMedicationPayload>(
    'intakeQuestionnaire/deleteIntakeMedication',
    async ({ intakeQuestionnaireId, medicationId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/medication/${medicationId}`,
        getAccessTokenSilently,
      });
    },
  );
}

function deleteAllIntakeMedications() {
  return createAsyncThunk<void, DeleteAllIntakeMedicationsPayload>(
    'intakeQuestionnaire/deleteAllIntakeMedications',
    async ({ intakeQuestionnaireId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}/medication/all`,
        getAccessTokenSilently,
      });
    },
  );
}

function setIntakeHasNoMedications() {
  return createAsyncThunk<void, SetIntakeHasNoMedicationsPayload>(
    'intakeQuestionnaire/setIntakeHasNoMedications',
    async ({ intakeQuestionnaireId, hasNoMedications, getAccessTokenSilently }) => {
      await fetchWrapper.patch(
        {
          url: `${INTAKE_QUESTIONNAIRES_API_BASE}/${intakeQuestionnaireId}`,
          getAccessTokenSilently,
        },
        { has_no_medications: hasNoMedications },
      );
    },
  );
}
